var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config)?_c('div',[(_vm.configPoints)?_c('custom-canvas',{attrs:{"config":_vm.configPoints,"locale":_vm.locale}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }